module.exports = [{
      plugin: require('/home/aulon/git/praha.knowit.no/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/aulon/git/praha.knowit.no/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
